import navbar from '../components/navbar/navbar.component';
import footer from '../components/footer/footer.component';
import authInterceptor from '../components/util/auth.interceptor';
import util from '../components/util/util.module';
import socket from '../components/socket/socket.service';
import AuthService from '../components/services/auth-service';

export const COMPONENTS = [
    authInterceptor,
    navbar,
    footer,     
    util,
    socket,
    AuthService
];


// WEBPACK FOOTER //
// ./client/app/components.js